import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import classNames from "classnames"
import instanceOfClassName from "@kaspernj/api-maker/build/instance-of-class-name"
import Link from "@kaspernj/api-maker/build/link"
import memo from "set-state-compare/build/memo"
import PropTypes from "prop-types"
import React from "react"
import Routes from "shared/routes"
/**
 * @typedef {object} ComponentsContactTypesLinkProps
 * @property {unknown} adminLayout
 * @property {unknown} children
 * @property {string} className
 * @property {unknown} contactType
 * @property {unknown} userLayout
 */

/** @typedef {object} ComponentsContactTypesLinkState */

/**
 * @extends {ShapeComponent<ComponentsContactTypesLinkProps, ComponentsContactTypesLinkState>}
 */
class ComponentsContactTypesLink extends ShapeComponent {
  static defaultProps = {
    adminLayout: false,
    userLayout: false
  }

  static propTypes = {
    adminLayout: PropTypes.bool.isRequired,
    className: PropTypes.string,
    contactType: instanceOfClassName("ContactType").isRequired,
    userLayout: PropTypes.bool.isRequired
  }

  render() {
    const {adminLayout, children, className, contactType, userLayout, ...restProps} = this.props
    const generatedClassName = classNames("components--check-ins--link", className)
    const to = this.to()

    if (to) {
      return (
        <Link className={generatedClassName} to={to} {...restProps}>
          {children || contactType.name()}
        </Link>
      )
    }

    return (
      <span className={generatedClassName} {...restProps}>
        {children || contactType.name()}
      </span>
    )
  }

  to() {
    const {adminLayout, contactType} = this.p

    if (adminLayout) return Routes.superAdminPath({model: "ContactType", model_id: contactType.id()})
  }
}

export default memo(shapeComponent(ComponentsContactTypesLink))
